'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import Link from 'next/link';
import { CategoryTreeEntity } from '@/src/lib/category-trees/types.ts';
import classNames from 'classnames';
import styles from './category-navigation.module.css';
import { useSearchParams } from 'next/navigation';
import { filterBlockedParams } from '@/src/lib/category-trees/business/category-trees-params.ts';
import { IconName } from '@/src/app/components/Icon/types.ts';
import Icon from '@/src/app/components/Icon/Icon.tsx';
import { transformURLForFrontendPaths } from '@/src/lib/utils/url.ts';
function ExpandButton(t0) {
  const $ = _c(12);
  const {
    expanded,
    onClick,
    nodeId
  } = t0;
  let t1;
  if ($[0] !== nodeId || $[1] !== onClick) {
    t1 = function onButtonClick(e) {
      e.preventDefault();
      onClick(nodeId);
    };
    $[0] = nodeId;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onButtonClick = t1;
  const t2 = expanded ? IconName.REMOVE : IconName.ADD;
  const t3 = !expanded;
  let t4;
  if ($[3] !== expanded || $[4] !== t3) {
    t4 = classNames("block! h-5 w-5", {
      "text-[22px]!": t3,
      "text-[18px]! mt-1": expanded
    });
    $[3] = expanded;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <Icon name={t2} className={t4} />;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onButtonClick || $[10] !== t5) {
    t6 = <button className="block mr-1 group-[.bg-black]:text-primary" onClick={onButtonClick}>{t5}</button>;
    $[9] = onButtonClick;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export function NavigationLayer(t0) {
  const $ = _c(10);
  const {
    categoryData,
    layerIndex,
    className,
    activeNodeId,
    lang,
    country,
    expandedParentNodeIds
  } = t0;
  let t1;
  if ($[0] !== activeNodeId || $[1] !== expandedParentNodeIds) {
    t1 = [activeNodeId, ...expandedParentNodeIds];
    $[0] = activeNodeId;
    $[1] = expandedParentNodeIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [expandedNodeIds, setExpandedNodeIds] = useState(t1);
  const linkClasses = classNames("flex items-center py-3 px-5 no-underline! text-gray-900 hover:bg-gray-100 group", {
    "font-bold": layerIndex === 0,
    [styles.linkLevel1]: layerIndex === 1,
    [styles.linkLevel2]: layerIndex === 2,
    [styles.linkLevel3]: layerIndex === 3
  });
  const searchParams = useSearchParams();
  let t2;
  if ($[3] !== expandedNodeIds) {
    t2 = nodeId => {
      if (expandedNodeIds.includes(nodeId)) {
        setExpandedNodeIds(expandedNodeIds.filter(id => id !== nodeId));
        return;
      }
      setExpandedNodeIds([...expandedNodeIds, nodeId]);
    };
    $[3] = expandedNodeIds;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onExpandClick = t2;
  let t3;
  if ($[5] !== className) {
    t3 = classNames("divide-y divide-gray-200 border-t border-gray-200", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = categoryData.map(child => {
    const isDirectActiveParent = child.children.some(subChild => subChild.nodeId === activeNodeId);
    const classes = classNames(linkClasses, {
      "font-bold": layerIndex === 0 || child.nodeId === activeNodeId || child.children.length,
      "bg-gray-100": child.nodeId === activeNodeId,
      "bg-black text-white hover:bg-black!": isDirectActiveParent
    });
    return <li key={child.nodeId || child.name}>{child.url ? <Link className={classes} href={{
        pathname: transformURLForFrontendPaths(child.url, lang, country),
        query: searchParams ? filterBlockedParams(new URLSearchParams(searchParams)).toString() : undefined
      }} prefetch={false} scroll={false}>{child.children?.length ? <ExpandButton expanded={expandedNodeIds.includes(child.nodeId)} onClick={onExpandClick} nodeId={child.nodeId} /> : null}<span className={classNames({
          "pl-6": !child.children?.length && child.nodeId !== 1
        })}>{child.name}</span><span className={classNames("ml-auto", {
          "font-normal": child.nodeId !== activeNodeId && !isDirectActiveParent,
          "font-semibold": isDirectActiveParent
        })}>({child.productCount})</span></Link> : <span className={classes}>{child.children?.length ? <ExpandButton expanded={expandedNodeIds.includes(child.nodeId)} onClick={onExpandClick} nodeId={child.nodeId} /> : null}<span>{child.name}</span></span>}{child.children?.length ? <NavigationLayer categoryData={child.children} layerIndex={layerIndex + 1} activeNodeId={activeNodeId} expandedParentNodeIds={expandedParentNodeIds} lang={lang} country={country} className={classNames({
        hidden: !expandedNodeIds.includes(child.nodeId)
      })} /> : null}</li>;
  });
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}